

const columnList: Array<any> = [
    {
        prop: "name",
        label: "项目名称",
        width: 164,
    },
    {
        prop: "project_type_name",
        label: "项目分类",
        width: 164,
    },
    {
        prop: "middle_price",
        label: "售价",
        width: 80,
    },
    {
        prop: "store_name",
        label: "门店名称",
        width: 80,
    },
];

interface Person {
    name:string;
    age:number;
}

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "projectManage",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["项目推荐"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            screenParameter = reactive({
                store_id: -1,
                search:''
            }),
            selectList = reactive({
                storeList:[] as any
            }) ,
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(1);
        
        
        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Project/platList',
                    data: {
                        page:currentPage.value,
                        pageSize:pageSize.value,
                        store_id:screenParameter.store_id,
                        search:screenParameter.search
                    }
                }).then((res: any) => {
                    tableData.value = res.content.list;
                    total.value = res.content.count;
                    loading.value = false;
                })
            },
            columnChange = (status: number,id: number) => {
                if(id){
                    Request.axiosInstance({
                        url: 'adminapi/Project/changeRecommend',
                        data: {
                            project_id: id,
                            status
                        }
                    }).then((res: any) => {
                    })
                }
            },
            selectChange = (()=>{
                currentPage.value = 1;
                getTableData();
            }),
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };
        onMounted(async() => {
            getTableData();
            await Request.axiosInstance({
                url: 'adminapi/Framework/totalList'
            }).then((res: any) => {
                selectList.storeList = [{id:-1,store_name:"请选择"},...res?.content?.list];
            })
        });
        
        return {
            loading,
            tableData,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            screenParameter,
            selectList,
            columnChange,
            selectChange
        };
    },
});
